<template>
  <div
    v-if="visible"
    class="row mb-3">
    <div
      v-for="b in btnData"
      :key="b.id"
      class="col-md-6 text-center">
      <a
        :href="b.link"
        target="_blank"
        class="btn btn-sm btn-info text-light m-2 w-100">
        {{b.text}}
      </a>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  // Initialize  
  const store = useStore()
  const props = defineProps(['product'])
  const allowedComp = ['Lancaster Canada', 'Lancaster US']
  const allowedLines = ['GRACO', 'TITAN']

  // Methods
  const getLink = (id)=>{
    if(id == 1){
      switch(props.product.buyline){
        case 'GRACO':
          return 'https://www.graco.com/us/en/contractor/how-to-buy/current-offers.html'
        case 'TITAN':
          return 'https://www.titantool.com/promotions'
      }
    }
    if(id == 2){
      switch(props.product.buyline){
        case 'GRACO':
          return 'https://redeem-graco.tbistores.com/redeem'
        case 'TITAN':
          return 'https://www.titantool.com/customer/account/login'
      }
    }
  }

  // Data
  const btnData = [
    {
      id: 1,
      text: 'Earn Free Parts & Accessories',
      link: getLink(1)
    },
    {
      id: 2,
      text: 'Redeem Free Offers Here',
      link: getLink(2)
    }
  ]

  // Computed
  const visible = computed(()=>{
    return allowedComp.includes(store.getters.sessionCompany) && allowedLines.includes(props.product.buyline)
  })
</script>